import yup from "../../../../utils/yup";

export const customEmailSchema = yup.object({
  address: yup
    .string()
    .email("Please enter a valid email address.")
    .required("Please enter a valid email address."),
  from_name: yup.string().optional().nullable(),
  reply_to: yup.string().optional().nullable(),
});

export type CustomEmail = yup.InferType<typeof customEmailSchema>;

export const customEmailDomainSchema = yup.object({
  domain: yup
    .string()
    .domain("Please enter a valid domain.")
    .required("Please enter a valid domain."),
});

export type CustomEmailDomain = yup.InferType<typeof customEmailDomainSchema>;

export const customEmailHeaderSchema = yup.object({
  display_name: yup.string().required("Please enter a display name."),
  header_name: yup
    .string()
    .required("Please enter a header name.")
    .matches(
      /^[!-9;-@A-~]+$/,
      "Header name must only contain ASCII characters, with no spaces or colons.",
    ),
  header_value: yup
    .string()
    .required("Please enter a header value.")
    .matches(/^[ -~]*$/, "Header value must only contain ASCII characters."),
});

export type CustomEmailHeaderFormValues = yup.InferType<typeof customEmailHeaderSchema>;

export type CustomEmailHeader = {
  id: string;
  header_name: string;
  header_value: string;
  display_name: string;
};
